if (!customElements.get('mossa-footer-accordion')) {
  customElements.define(
    'mossa-footer-accordion',
    class MossaFooterAccordion extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.mossa-footer__accordion-item').forEach((item) => {
          const trigger = item.querySelector('.mossa-footer__accordion-trigger');
          const panel = item.querySelector('.mossa-footer__accordion-panel');
          if (!trigger || !panel) return;

          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          item.classList.remove('is-open');
        });

        this.querySelectorAll('.mossa-footer__accordion-trigger').forEach((trigger) => {
          if (trigger.dataset.bound === 'true') return;
          trigger.dataset.bound = 'true';
          trigger.addEventListener('click', this.onTriggerClick.bind(this));
        });
      }

      onTriggerClick(event) {
        const trigger = event.currentTarget;
        const item = trigger.closest('.mossa-footer__accordion-item');
        const panel = item.querySelector('.mossa-footer__accordion-panel');
        if (!panel) return;

        const isOpen = item.classList.contains('is-open');

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        item.classList.toggle('is-open', !isOpen);
      }
    }
  );
}
